/**
 * Helper function to determine if this apollo is loading data
 * for the first time, and not refetching it.
 *
 * In 2.x versions, the `loading` prop defaults to true when the
 * network is either loading the data for the first time, _or_
 * has kicked off a refetch request. They recommend using the
 * networkStatus prop to determine if a component is in a refetching
 * state versus an initial load.
 *
 * @param  {number} networkStatus - Network status enum from apollo
 * @return {boolean}              - Is data loading for the first time
 */
export function isFirstLoad(networkStatus: number) {
    // 1 = "initial load" (4 = "refetching", 7 = "not fetching")
    return networkStatus === 1;
}
